import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Row, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addCustomer } from "../../redux/actions/customer/addCustomerAciton";
import UploadCustomerExcel from "./UploadCustomerExcel";
import styles from "./AddCust.module.css";

const AddCust = ({ onSuccess = null, inModal = false, onCancel = null, prefilledName = '' }) => {
	const dispatch = useDispatch();
	const { Title } = Typography;
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	useEffect(() => {
		if (inModal && prefilledName && form) {
			form.setFieldsValue({ name: prefilledName });
		}
	}, [inModal, prefilledName, form]);

	const onClick = () => setLoading(true);

	const onFinish = async (values) => {
		try {
			const payload = {
				...values,
				opening_balance: values.opening_balance != null ? values.opening_balance : 0,
				opening_balance_date: values.opening_balance_date ? values.opening_balance_date.format("YYYY-MM-DD") : undefined,
			};
			const resp = await dispatch(addCustomer(payload));
			if (resp.message === "success") {
				setLoading(false);
				form.resetFields();
				if (inModal && onSuccess) onSuccess(resp.data || null);
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
			console.log(error.message);
		}
	};

	const onFinishFailed = (errorInfo) => {
		setLoading(false);
		console.log("Failed:", errorInfo);
	};

	const formContent = (
		<Form
			form={form}
			name='basic'
			labelCol={{ span: inModal ? 6 : 7 }}
			wrapperCol={{ span: inModal ? 18 : 16 }}
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete='off'
		>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Name'
				name='name'
				rules={[{ required: true, message: "Please input customer name!" }]}
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Phone'
				name='phone'
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Address'
				name='address'
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Opening Balance'
				name='opening_balance'
			>
				<InputNumber min={0} style={{ width: "100%" }} placeholder="0" />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label={
					<span>
						Date
						<Tooltip title="Opening Balance Date">
							<InfoCircleOutlined style={{ marginLeft: 4, color: "#999", cursor: "help" }} />
						</Tooltip>
					</span>
				}
				name='opening_balance_date'
			>
				<DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: inModal ? 0 : "10px" }}
				className={!inModal ? styles.addCustomerBtnContainer : undefined}
				wrapperCol={inModal ? { offset: 0, span: 18 } : undefined}
			>
				{inModal ? (
					<div style={{ display: "flex", justifyContent: "center", gap: 8, width: "100%" }}>
						<Button
							loading={loading}
							onClick={onClick}
							htmlType='submit'
							shape='round'
							style={{
								flex: 1,
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								textAlign: "center",
								backgroundColor: "#52c41a",
								borderColor: "#52c41a",
								color: "#fff",
							}}
						>
							Add Customer
						</Button>
						{onCancel && (
							<Button
								type="primary"
								danger
								shape="round"
								onClick={onCancel}
								style={{
									flex: 1,
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									textAlign: "center",
								}}
							>
								Cancel
							</Button>
						)}
					</div>
				) : (
					<Button loading={loading} onClick={onClick} type='primary' htmlType='submit' shape='round'>
						Add Customer
					</Button>
				)}
			</Form.Item>
		</Form>
	);

	if (inModal) return formContent;

	return (
		<Fragment>
			<Row className='mr-top' justify='space-between' gutter={[0, 30]}>
				<Col xs={24} sm={24} md={24} lg={11} xl={11} className='rounded column-design'>
					<Card bordered={false}>
						<Title level={4} className="text-center" style={{ backgroundColor: '#dadada', padding: '10px', margin: '0 !important' }}>
							Add Customer
						</Title>
						{formContent}
					</Card>
				</Col>
				<Col xs={24} sm={24} md={24} lg={11} xl={11} className='column-design rounded'>
					<Card bordered={false} className={styles.importCsvCard}>
						<Title level={4} className='m-2 text-center'>Import From Excel</Title>
						<UploadCustomerExcel onSuccess={onSuccess} />
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default AddCust;
